<section
    class="list-items"
    [ariaLabel]="listItems.length + ' Ergebnisse'"
>
    @for (listItem of listItems; track listItem.id) {
        <ui-list-item
            [listItem]="listItem"
            [itemContentComponentType]="itemContentComponentType"
        />
    }
</section>
